import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      height: '15%',
      width: '100%',
      //   border: '2px solid green',
      paddingTop: '20px',
    },
    formfield: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingBottom: '30px',
    },
    validatebuttons: {
      display: 'flex',
      flexDirection: 'row',
      //   border: '2px solid blue',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '50%',
    },
    fielddetails: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    selected: {
      width: '140px',
      height: '40px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginLeft: '20px',
    },
    selectedtext: {
      fontSize: '9px',
      color: '#545456',
      fontWeight: 'bold',
      marginLeft: '10px',
    },
  }),
  { index: 1 },
)

export { useStyles }
